import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z","key":"svg-0"}]]

const IconCropPortraitFilled = createReactComponent('filled', 'crop-portrait-filled', 'CropPortraitFilled', __iconNode);

export default IconCropPortraitFilled;